var _circle, _g, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1476_718",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 31,
    height: 30
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.9996,
    cy: 15,
    r: 14.9138,
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 0.172414
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1476_718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.29231 26.2072C6.29231 21.3985 10.1905 17.5003 14.9992 17.5003C19.8079 17.5003 23.7062 21.3985 23.7062 26.2072V28.7935C23.7062 33.6022 19.8079 37.5004 14.9992 37.5004C10.1905 37.5004 6.29231 33.6022 6.29231 28.7935V26.2072Z",
    stroke: "#053772",
    strokeWidth: 0.517243
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.9996,
    cy: 15,
    r: 14.7414,
    stroke: "#053772",
    strokeWidth: 0.517243
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.0853,
    cy: 11.9828,
    r: 5.17243,
    stroke: "#053772",
    strokeWidth: 0.517243
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.a4d385f1195dc7b73afff7dbaf6475f3.svg";
export { ForwardRef as ReactComponent };